const filtration = {
    init() {
        let self = this;
        let openButton = document.querySelector('.js-filtration-button');
        let filtresNode = document.querySelector('.js-filtration-node');
        let closeButton = document.querySelector('.js-filtration-close-button');

        if(filtration && openButton && closeButton) {
            self.fireInTheHole(openButton, filtresNode, closeButton);

            if(document.querySelector('body').classList.contains('overflow-hidden')) {
                document.querySelector('body').classList.remove('overflow-hidden');
            }
        }

    },

    fireInTheHole(openButton, filtresNode, closeButton) {
        let self = this;

        if(filtresNode.classList.contains('initialized')) {
            return;
        }

        filtresNode.classList.add('initialized');

        openButton.addEventListener('click', function(){
            event.preventDefault();
            filtresNode.classList.remove('hidden');
            document.querySelector('body').classList.add('overflow-hidden');
        });

        closeButton.addEventListener('click', function(){
            filtresNode.classList.add('hidden');
            document.querySelector('body').classList.remove('overflow-hidden');
        });
    }
}

filtration.init();

document.addEventListener('LokiRequestEnd', function () {
    filtration.init();
 });
 